import { INIT_PAGINATION } from '@spx-portal/shared-utils';
import { useRequest } from 'ahooks';
import { useState } from 'react';
import { ProTableProps } from 'react-pro-components/typings/components/pro-table/types';
import { message } from 'ssc-ui-react';

import { $gt } from '@/common/appCtx';

import { searchLogAdapter } from '../adapter';
import * as API from '../api';
import { exportBatchLogList } from '../api';
import { useFields } from '../fields/batch-fields';

export const useBatchTableProps = () => {
  const [pagination, setPagination] = useState(INIT_PAGINATION);
  const {
    loading,
    data,
    run: runLogList,
  } = useRequest(API.getBatchLogList, {
    manual: true,
    onSuccess(data) {
      const { total = 0, pageno = INIT_PAGINATION.current, count = INIT_PAGINATION.pageSize } = data;
      setPagination(prev => ({
        ...prev,
        total,
        current: pageno,
        pageSize: count,
      }));
    },
    onError(e) {
      console.error('Failed to fetch data:', e);
    },
  });

  const handleExport = async(id: number) => {
    // task center download case
    await exportBatchLogList({
      id,
    });
    message.success($gt('Exported Successfully!'));
  };

  const actionColumn = () => ({
    actions: (row: any) => [
      {
        children: $gt('Downloand'),
        onClick: () => {
          handleExport(row.id);
        },
      },
    ],
    width: 70,
  });

  const proTableProps: ProTableProps = {
    loading: loading,
    table: {
      dataSource: data?.list || [],
      columns: useFields().tableColumns,
      actionColumn: actionColumn(),
      rowKey: 'id',
      pagination,
      sticky: true,
    },
    searchForm: {
      footerProps: { showReset: false },
    },
    fetchData:{
      fetcher: async(info: any) => {
        const { current, pageSize } = info.pagination || INIT_PAGINATION;
        await runLogList({
          pageno: current,
          count: pageSize,
          ...searchLogAdapter(info.form),
        });
      },
      fetchOnMount: true,
      fetchOnFormChange: false,
      fetchOnFormReset: true,
      fetchOnFormSubmit: true,
      fetchOnTableChange: true,
    },
  };

  return proTableProps;
};
